import { useTranslation } from 'react-i18next';
import { TranslationKeys } from '../i18n/types/i18n.types';

interface UseI18nReturn {
  t: (key: keyof TranslationKeys | string, options?: Record<string, string>) => string;
  language: string;
  changeLanguage: (lng: string) => Promise<void>;
  ready: boolean;
}

export const useI18n = (): UseI18nReturn => {
  const { t, i18n, ready } = useTranslation();

  const changeLanguage = async (lng: string): Promise<void> => {
    await i18n.changeLanguage(lng);
  };

  return {
    t: (key: keyof TranslationKeys | string, options?: Record<string, string>) => {
      return t(key as string, options);
    },
    language: i18n.language,
    changeLanguage,
    ready,
  };
};

export default useI18n;
